// ** React Imports
import { lazy } from 'react';

const RefundsRoutes = [
  {
    path: 'refunds',
    component: lazy(() =>
      import('views/order-management/refunds/RefundListPage'),
    ),
  },
  {
    path: 'refund/details/:id',
    component: lazy(() =>
      import('views/order-management/refunds/RefundDetailsPage'),
    ),
  },
];

export default RefundsRoutes;
